module.exports = __webpack_public_path__ + "img/conteudo.6298ffb3.svg";